module.exports = require("react-router");


/*****************
 ** WEBPACK FOOTER
 ** external "react-router"
 ** module id = 10
 ** module chunks = 0
 **/